import React from "react"

import Container from "react-bootstrap/Container";

import logo from "../images/onlnecasino_logo.png";

const Header = () => (
  <header>
    <Container fluid = {true}>
        <div className="header-logo">
            <img src={logo} alt="Online Casino"/>
        </div>
    </Container>
  </header>
)

export default Header
